(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rms-vehicle-finder-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-rms-vehicle-finder]').forEach(root => {
      const managedRows = [...root.querySelectorAll('[data-rms-vehicle-record]')]
        .map(element => ({ ...element.dataset }))
        .filter(row => row.make && row.model && Number(row.from) && Number(row.to));
      let databaseRows = [];
      const database = root.querySelector('[data-rms-vehicle-database]');
      try {
        databaseRows = JSON.parse(database?.textContent || '[]').map(row => ({
          make: row[0],
          model: row[1],
          from: String(row[2]),
          to: String(row[3]),
          key: [row[0], row[1], row[2], row[3]].join('-').toLowerCase()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            .replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''),
          collection: 'vad-passar-min-bil-resultat',
          source: 'external'
        }));
      } catch (error) {
        console.warn('RMS vehicle database could not be read.', error);
      }
      const rows = [...managedRows, ...databaseRows];
      const make = root.querySelector('[data-rms-vehicle-make]');
      const model = root.querySelector('[data-rms-vehicle-model]');
      const year = root.querySelector('[data-rms-vehicle-year]');
      const form = root.querySelector('[data-rms-vehicle-form]');
      const fill = (select, values, label, numeric = false) => {
        select.innerHTML = '';
        select.add(new Option(label, ''));
        [...new Set(values)]
          .sort(numeric ? (a, b) => Number(b) - Number(a) : (a, b) => a.localeCompare(b, 'sv'))
          .forEach(value => select.add(new Option(value, value)));
      };
      const destinationFor = row => {
        const fallback = 'vad-passar-min-bil-resultat';
        if (row.collection && row.collection !== fallback && row.collection !== 'all') return row.collection;
        const makeHandle = make.value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        const modelHandle = model.value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        const audiModels = ['a1','a2','a3','a4','a5','a6','a7','a8','q3','q5','q7','r8','tt'];
        const volvoModels = ['s40','s60','s80','s90','v40','v60','v70','v90','xc70','xc90'];
        if (makeHandle === 'audi' && audiModels.includes(modelHandle)) return `audi-${modelHandle}`;
        if (makeHandle === 'volvo' && volvoModels.includes(modelHandle)) return `passar-volvo-${modelHandle}`;
        if (makeHandle === 'bmw') {
          const series = modelHandle.match(/^([1-8])(?:-series|-serie)?$/)?.[1];
          if (series) return `bmw-${series}-serie`;
          if (['x1','x3','x5','x6'].includes(modelHandle)) return `bmw-${modelHandle}`;
          return 'allt-for-bmw';
        }
        return fallback;
      };
      const makeLabel = make.options[0].text;
      const modelLabel = model.options[0].text;
      const yearLabel = year.options[0].text;
      fill(make, rows.map(row => row.make), makeLabel);
      make.addEventListener('change', () => {
        fill(model, rows.filter(row => row.make === make.value).map(row => row.model), modelLabel);
        fill(year, [], yearLabel, true);
        model.disabled = !make.value;
        year.disabled = true;
      });
      model.addEventListener('change', () => {
        const years = [];
        rows.filter(row => row.make === make.value && row.model === model.value).forEach(row => {
          for (let value = Number(row.to); value >= Number(row.from); value--) years.push(String(value));
        });
        fill(year, years, yearLabel, true);
        year.disabled = !model.value;
      });
      form.addEventListener('submit', event => {
        event.preventDefault();
        const matches = rows.filter(item =>
          item.make === make.value &&
          item.model === model.value &&
          Number(year.value) >= Number(item.from) &&
          Number(year.value) <= Number(item.to)
        );
        const managedMatches = matches.filter(item => item.source === 'registry' || item.source === 'fallback');
        const row = matches.sort((a, b) => {
          const sourcePriority = { registry: 0, fallback: 1, external: 2 };
          const priority = (sourcePriority[a.source] ?? 3) - (sourcePriority[b.source] ?? 3);
          return priority || (Number(a.to) - Number(a.from)) - (Number(b.to) - Number(b.from));
        })[0];
        if (!row) return;
        const vehicle = {
          make: make.value,
          model: model.value,
          year: year.value,
          key: row.key,
          generation: row.generation || '',
          body: row.body || '',
          facelift: row.facelift || '',
          originalAudio: row.originalAudio || '',
          amplifier: row.amplifier || '',
          fitmentVerified: managedMatches.length === 1
        };
        localStorage.setItem('rms-selected-vehicle', JSON.stringify(vehicle));
        document.dispatchEvent(new CustomEvent('rms:vehicle-selected', { detail: vehicle }));
        const collection = destinationFor(row);
        const params = new URLSearchParams({
          rms_make: make.value,
          rms_model: model.value,
          rms_year: year.value,
          rms_vehicle: row.key
        });
        location.href = `${window.Shopify?.routes?.root || '/'}collections/${collection}?${params}`;
      });
      let saved = null;
      try {
        saved = JSON.parse(localStorage.getItem('rms-selected-vehicle') || 'null');
      } catch (error) {}
      if (saved && rows.some(row => row.make === saved.make)) {
        make.value = saved.make;
        make.dispatchEvent(new Event('change'));
        model.value = saved.model;
        model.dispatchEvent(new Event('change'));
        year.value = saved.year;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
